// @flow
export default {
  lumeraLightBlue: 'rgb(56, 113, 182)',
  lumeraMidBlue: 'rgb(33, 82, 141)',
  lumeraDarkBlue: 'rgb(45, 64, 102)',
  lumeraYellow: 'rgb(256, 169, 19)',
  lumeraLightGray: 'rgb(246, 246, 246)',

  lumeraDarkGray: 'rgb(127, 127, 127)'
};
